import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { r as remCalc } from './index5.js';
import { D as DomService, T as TrackingService } from './index3.js';
import { R as RocheModalTrigger } from './roche-modal-trigger.js';
import './index2.js';
import { A as AdobeTracking } from './index7.js';
import { d as defineCustomElement$1 } from './roche-icon2.js';

var RocheGenericLinkIconPosition;
(function (RocheGenericLinkIconPosition) {
    RocheGenericLinkIconPosition["BEFORE"] = "before";
    RocheGenericLinkIconPosition["AFTER"] = "after";
})(RocheGenericLinkIconPosition || (RocheGenericLinkIconPosition = {}));
var RocheGenericLinkTarget;
(function (RocheGenericLinkTarget) {
    RocheGenericLinkTarget["BLANK"] = "_blank";
    RocheGenericLinkTarget["PARENT"] = "_parent";
    RocheGenericLinkTarget["SELF"] = "_self";
    RocheGenericLinkTarget["TOP"] = "_top";
})(RocheGenericLinkTarget || (RocheGenericLinkTarget = {}));
var RocheGenericLinkSize;
(function (RocheGenericLinkSize) {
    RocheGenericLinkSize["TINY"] = "tiny";
    RocheGenericLinkSize["EXTRA_SMALL"] = "extra-small";
    RocheGenericLinkSize["SMALL"] = "small";
    RocheGenericLinkSize["MEDIUM"] = "medium";
    RocheGenericLinkSize["NAVIGATION"] = "navigation";
    RocheGenericLinkSize["LARGE"] = "large";
    RocheGenericLinkSize["EXTRA_LARGE"] = "extra-large";
    RocheGenericLinkSize["HUGE"] = "huge";
    RocheGenericLinkSize["EXTRA_HUGE"] = "extra-huge";
})(RocheGenericLinkSize || (RocheGenericLinkSize = {}));

const rocheGenericLinkCss = ":host{display:block;margin-top:3rem;color:var(--color-interactive--primary-idle);margin-top:0.5rem;display:inline-block}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0.9375rem}}:host .icon{fill:currentcolor;position:relative;top:0.125rem;display:inline-block;margin-right:0.5rem}:host .link{color:inherit;text-decoration:none}:host .link:focus,:host .link:focus-visible{outline:var(--color-interactive--focus) dashed 2px;outline-offset:unset}:host .link:focus:not(:focus-visible){outline:none}:host .link:hover{text-decoration:none;color:var(--color-interactive--primary-hover)}:host .link:active,:host .link--active{color:var(--color-interactive--active)}:host .link--underline:hover{text-decoration:underline}:host .link--matches-current-route{color:var(--color-interactive--primary-hover)}:host .link--search-filter{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;border:1px solid #fff;color:#fff;padding:0.375rem 0.5rem}@media (min-width: 64rem){:host .link--search-filter{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}:host .link--search-filter:hover{background-color:#fac47a;border-color:#fac47a;color:#000;cursor:pointer;text-decoration:none}:host .link--search-filter--active{background-color:#fac47a;border-color:#fac47a;color:#000}:host .link--search-filter roche-icon{margin-right:0}:host .link--close-search{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;color:#ffc414;display:flex;align-items:center}@media (min-width: 64rem){:host .link--close-search{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}:host .link--close-search:hover{color:#ffc414;cursor:pointer;text-decoration:none}:host .link--close-search roche-icon{top:0}:host .link-container{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:var(--body-small--font-size--small-up);line-height:1.625rem;color:inherit;font-weight:200;display:inline-block;line-height:1.3}@media (min-width: 48rem){:host .link-container{font-size:var(--body-small--font-size--medium-up);line-height:1.8125rem}}:host .link-container--tiny{font-size:0.4375rem}:host .link-container--extra-small{font-size:0.625rem}:host .link-container--small{font-size:0.875rem}:host .link-container--navigation{font-size:1rem}:host .link-container--large{font-size:1.25rem}:host .link-container--extra-large{font-size:1.5625rem}:host .link-container--huge{font-size:1.875rem}:host .link-container--extra-huge{font-size:2.125rem}:host .link-container--search-filter{margin:0 0.75rem 0.75rem 0}:host .link-container:active .link{color:var(--color-interactive--active)}:host .text{margin-right:0.3125rem}:host .meta{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-size:0.875rem;font-weight:400;line-height:1.1875rem;color:var(--color-text--secondary);color:#999}@media (min-width: 48rem){:host .meta{font-size:1rem;line-height:1.3125rem}}:host-context([theme=dark]){color:#fff}:host([type=search-icon]){--color-interactive--primary-hover:currentcolor}:host([type=search-icon]) .link-container{line-height:0}:host([type=search-icon]) roche-icon,:host([type=search-icon]) .text{margin:0}:host([type=search-icon]) roche-icon{position:relative;top:0.25rem}:host([type=breadcrumbs]){margin-top:0;}@media (min-width: 64rem){:host([type=breadcrumbs]){margin-top:0}}:host([type=breadcrumbs]) .link--breadcrumbs{color:#544f4f;outline:none}:host([type=breadcrumbs]) .link--breadcrumbs:hover{color:var(--color-interactive--primary-hover);text-decoration:none}:host([type=breadcrumbs]) .link--breadcrumbs:not([href]){color:#544f4f}:host([type=breadcrumbs]) .link--breadcrumbs:focus span,:host([type=breadcrumbs]) .link--breadcrumbs:focus-visible span{outline:2px dashed var(--color-interactive--focus)}:host([type=breadcrumbs]) .link--breadcrumbs:focus:not(:focus-visible) span{outline:none}:host([type=breadcrumbs]) .link--breadcrumbs roche-icon{color:var(--color-text--secondary);margin:auto 0.5rem}@media (min-width: 48rem){:host([type=breadcrumbs]) .link--breadcrumbs roche-icon{margin:auto 0.75rem}}@media (min-width: 90rem){:host([type=breadcrumbs]) .link--breadcrumbs roche-icon{margin:auto 1rem}}:host([type=breadcrumbs]) .link--breadcrumbs--underline:hover{text-decoration:underline}:host([type=breadcrumbs]) .link-container--breadcrumbs{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-weight:400;font-size:var(--label--font-size--small-up);line-height:1.3125rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline}@media (min-width: 48rem){:host([type=breadcrumbs]) .link-container--breadcrumbs{font-size:var(--label--font-size--medium-up);line-height:1.3125rem}}:host([type=breadcrumbs]) .link-container--breadcrumbs:active .link{color:var(--color-interactive--active)}:host([data-theme=dark]){color:#fff}:host([data-theme=dark]) .link:hover{text-decoration:none;color:#fac47a}:host([data-theme=dark]) .link--active{text-decoration:none;color:#ffc414}:host([data-theme=dark]) .link:focus{outline:none}:host([data-theme=dark]) .text{margin:0}:host([bold]) .text{font-weight:800}:host([type=navigation]){margin-top:0}@media (min-width: 64rem){:host([type=navigation]){margin-top:0.4375rem;margin-right:1.5rem}}:host([type=navigation]) .link{color:var(--color-interactive--primary-idle)}:host([type=navigation]) .link::after{content:\"\";display:block;margin:0.5rem auto auto;height:2px;width:0%;background:transparent;transition:width 0.5s ease, background-color 0.5s ease}@media (min-width: 64rem){:host([type=navigation]) .link::after{margin-top:0;margin-bottom:0.1875rem}}:host([type=navigation]) .link:hover{color:var(--color-interactive--primary-hover);text-decoration:none}:host([type=navigation]) .link:hover::after{width:100%;background:var(--color-interactive--primary-hover)}:host([type=navigation]) .link .text{margin:0}:host-context(.microsite) .link-container{font-weight:400}:host([dir=rtl]) .link-container{display:inline-flex;align-items:baseline}:host([dir=rtl]) .icon{margin-left:0.5rem;margin-right:0}:host([dir=rtl]) .text{margin-left:0.3125rem;margin-right:0}";
const RocheGenericLinkStyle0 = rocheGenericLinkCss;

/** This component is deprecated please
*   use roche-text-link insted. */
const iconsSizeMap = {
    [RocheGenericLinkSize.TINY]: `${remCalc(8)}rem`,
    [RocheGenericLinkSize.EXTRA_SMALL]: `${remCalc(10)}rem`,
    [RocheGenericLinkSize.SMALL]: `${remCalc(12)}rem`,
    [RocheGenericLinkSize.MEDIUM]: `${remCalc(14)}rem`,
    [RocheGenericLinkSize.NAVIGATION]: `${remCalc(16)}rem`,
    [RocheGenericLinkSize.LARGE]: `${remCalc(18)}rem`,
    [RocheGenericLinkSize.EXTRA_LARGE]: `${remCalc(20)}rem`,
    [RocheGenericLinkSize.HUGE]: `${remCalc(24)}rem`,
    [RocheGenericLinkSize.EXTRA_HUGE]: `${remCalc(32)}rem`,
};
const RocheGenericLink = /*@__PURE__*/ proxyCustomElement(class RocheGenericLink extends HTMLElement {
    // eslint-disable-next-line class-methods-use-this
    get defaultTracking() {
        return {
            event: 'link_click',
            component_name: 'text-link',
            additionalParameters: {
                click_url: this.url,
                click_text: this.text,
            },
        };
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.rocheIconLinkClick = createEvent(this, "roche-generic-link-click", 7);
        this.text = undefined;
        this.isModalTrigger = false;
        this.isSearchTrigger = false;
        this.bold = undefined;
        this.active = undefined;
        this.content = undefined;
        this.meta = undefined;
        this.url = undefined;
        this.icon = undefined;
        this.type = undefined;
        this.iconPosition = RocheGenericLinkIconPosition.BEFORE;
        this.iconColor = undefined;
        this.size = RocheGenericLinkSize.MEDIUM;
        this.target = RocheGenericLinkTarget.SELF;
        this.isFilterActive = false;
        this.underline = true;
        this.showOnetrustSettings = undefined;
        this.matchesCurrentRoute = false;
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick(event) {
        if (this.isModalTrigger && !this.isSearchTrigger) {
            event.preventDefault();
            RocheModalTrigger.trigger(this.element.id);
        }
        if (this.isSearchTrigger) {
            event.preventDefault();
            RocheModalTrigger.trigger('roche-search');
        }
        this.trackClick(event);
        this.rocheIconLinkClick.emit(event);
    }
    componentDidLoad() {
        this.handleCurrentRouteVerification();
        DomService.handleTextDirection(this.element);
    }
    render() {
        const iconSize = iconsSizeMap[this.size];
        const linkContainerClasses = {
            'link-container': true,
            [`link-container--${this.size}`]: true,
            'link-container--breadcrumbs': this.type === 'breadcrumbs',
            'link-container--search-filter': this.type === 'search-filter',
        };
        const linkAttributes = {
            href: this.url,
            target: this.target,
        };
        const IconElement = this.icon && h("roche-icon", { key: 'b9a02e3a30d6f495ec88acadaee7d127f53f360e', class: "icon", style: { fill: this.iconColor }, icon: this.icon, width: iconSize, height: iconSize });
        const linkClasses = {
            link: true,
            'link--underline': this.underline,
            'link--breadcrumbs': this.type === 'breadcrumbs',
            'link--close-search': this.type === 'search',
            'link--search-filter': this.type === 'search-filter',
            'link--search-filter--active': this.type === 'search-filter' && this.isFilterActive,
            'link--active': this.active,
            'link--matches-current-route': this.matchesCurrentRoute,
            'ot-sdk-show-settings': this.showOnetrustSettings,
        };
        return (h(Host, { key: '42fdaa324acf2fa57c0ef74223705ced0b0b1523' }, this.content && (h("a", Object.assign({ class: linkClasses }, linkAttributes, { onClick: this.handleClick }), h("slot", null, this.content))), !this.content && (this.text || this.icon) && (h("div", { class: linkContainerClasses }, h("a", Object.assign({ class: linkClasses }, linkAttributes, { onClick: this.handleClick }), this.iconPosition === RocheGenericLinkIconPosition.BEFORE && IconElement, h("span", { class: "text" }, this.text), this.iconPosition === RocheGenericLinkIconPosition.AFTER && IconElement), this.meta && h("span", { class: "meta" }, this.meta)))));
    }
    handleCurrentRouteVerification() {
        if (!(this.size === RocheGenericLinkSize.NAVIGATION) || !this.url) {
            return;
        }
        const activeRoute = window.location.pathname
            .split('/')
            .filter((el) => el !== '')
            .pop();
        const targetRoute = this.url
            .split('/')
            .filter((el) => el !== '')
            .pop();
        if (activeRoute && activeRoute.includes(targetRoute)) {
            this.matchesCurrentRoute = true;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    get adobeTracking() {
        return {
            innerText: this.text,
            url: this.url,
            position: 'GenericLink',
            type: this.type || 'Button',
            socialMedia: '',
            socialInteraction: '',
        };
    }
    trackClick(event) {
        TrackingService.push(Object.assign(Object.assign({}, this.defaultTracking), TrackingService.getParentAwareTrackingInfo(event)));
        AdobeTracking(this.adobeTracking, 'defaultLinkClick');
    }
    get element() { return this; }
    static get style() { return RocheGenericLinkStyle0; }
}, [1, "roche-generic-link", {
        "text": [1],
        "isModalTrigger": [4, "is-modal-trigger"],
        "isSearchTrigger": [4, "is-search-trigger"],
        "bold": [516],
        "active": [4],
        "content": [1],
        "meta": [1],
        "url": [1],
        "icon": [1],
        "type": [513],
        "iconPosition": [1, "icon-position"],
        "iconColor": [8, "icon-color"],
        "size": [1],
        "target": [1],
        "isFilterActive": [4, "is-filter-active"],
        "underline": [4],
        "showOnetrustSettings": [4, "show-onetrust-settings"],
        "matchesCurrentRoute": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-generic-link", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-generic-link":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheGenericLink);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { RocheGenericLink as R, RocheGenericLinkIconPosition as a, defineCustomElement as d };

//# sourceMappingURL=roche-generic-link2.js.map